import React from 'react'
import { TopLayoutProps } from './types'
import { Footer } from 'spa/member/components/Top/Footer'
import { TechLayout } from 'spa/member/layouts/TechLayout'
import { EnterpriseFooter } from 'spa/member/components/Top/EnterpriseFooter'
import { ProductHeader } from '../../components/Top/ProductHeader'

export const StyledTopLayout: React.FC = (props: TopLayoutProps) => {
  return (
    <>
      <TechLayout>
        <ProductHeader />
        {props.children}
        <Footer />
        <EnterpriseFooter />
      </TechLayout>
    </>
  )
}
